// extracted by mini-css-extract-plugin
export default {"emailSummaryExplanation":"hCyyZvzh1X","toggleWrapper":"JTQmcssk2T","toggleLabel":"YET3DQGeyK"};